export default __webpack_public_path__ + "static/media/element_85.80fc3939.avif";